export default __webpack_public_path__ + "static/media/ilmattino.0d0d2fd8.png";